import React from 'react';
import classNames from 'classnames/bind';
import styles from './TopHero.module.scss';

let cx = classNames.bind(styles);

export default function TopHero() {
  return (
    <div>
      <section className={cx('heroSection')}>
        <div className={cx('container')}>
          <div className={cx('content')}>
            <span className={cx('smallHeader', 'skeleton')} />
            <h1 className={cx('title', 'skeleton')} />
            <div className={cx('textButtonWrapper')}>
              <div className={cx('textWrapper')}>
                <div className={cx('subText', 'skeleton')} />
                <div className={cx('subText', 'skeleton', 'shorter')} />
              </div>
              <div className={cx('buttonWrapper')}>
                <div className={cx('button', 'skeleton')} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={cx('contentSection')}>
        <div className={cx('container')}>
          <div className={cx('gridContainer')}>
            {[1, 2, 3].map((item) => (
              <div key={item} className={cx('gridItem')}>
                <div className={cx('imageBox', 'skeleton')} />
                <div className={cx('itemContent')}>
                  <div className={cx('itemTitle', 'skeleton')} />
                  <div className={cx('itemText', 'skeleton')} />
                  <div className={cx('itemText', 'skeleton', 'shorter')} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
} 